



































import Vue from "vue";
import { AxiosResponse } from "axios";
import { myAuctionApi } from "../../utils/axios";

export default Vue.extend({
  name: "Success",

  data: () => ({
    payInfo : {},
    newDate: ""
  }),
  created () {
    // console.log(this.$route.query.pg_token);
    const token = this.$route.query.pg_token
    myAuctionApi.success(token).then((res: AxiosResponse) => {
      this.payInfo = res.data.object;
      const date = res.data.object.paymentDate.split(' ');
      date.reverse();
      const newdate = [date[0], date[4], date[3], date[5], date[2]];
      this.newDate = newdate.join(' ')
    })
  }
});
